import { HostMessageType } from '../../interfaces/host-message-types';
import { sendMessageToHost } from '../base/models/base-message';
import { MessageHandler } from '../base/interfaces/message.interface';
import { CancelModelUploadPayload } from './interfaces/cancel-model-upload-payload.interface';

export const CancelModelUploadMessage: MessageHandler<CancelModelUploadPayload> = {
  send(payload: CancelModelUploadPayload, targetOrigin = '*'): void {
    sendMessageToHost(HostMessageType.CancelModelUpload, payload, targetOrigin);
  },

  validatePayload(payload: unknown): payload is CancelModelUploadPayload {
    if (!payload || typeof payload !== 'object') {
      return false;
    }

    const p = payload as Record<string, unknown>;
    if (!Array.isArray(p['items'])) {
      return false;
    }

    return p['items'].every(
      item =>
        item &&
        typeof item === 'object' &&
        typeof item.id === 'string' &&
        typeof item.projectId === 'string' &&
        typeof item.teamId === 'string'
    );
  },
};
